import { PixelRatio } from 'react-native';

/** CSS pixels per device pixel. Web uses `window.devicePixelRatio`. */
export function devicePixelRatio(): number {
  if (typeof PixelRatio.get !== 'function') {
    return 1;
  }
  const ratio = PixelRatio.get();
  return ratio > 0 ? ratio : 1;
}
